import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-417210b3"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-bottom": "8px"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#1866E9"
  }
}, "荣誉"), /*#__PURE__*/_createTextVNode("课程 ")]), /*#__PURE__*/_createElementVNode("img", {
  height: "25",
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202306/18241f51cafb49578abe552382972dd9.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("div")], -1));

const _hoisted_3 = {
  class: "course-content"
};
const _hoisted_4 = {
  class: "course-data"
};
const _hoisted_5 = {
  class: "course-list"
};
const _hoisted_6 = {
  key: 0,
  class: "classify-box"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "course-card-list"
};
const _hoisted_9 = {
  key: 1,
  class: "no-data"
};
const _hoisted_10 = {
  class: "user-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CourseCard = _resolveComponent("CourseCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_UserCard = _resolveComponent("UserCard");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.typeList && $data.typeList.length ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("ul", {
    class: _normalizeClass(["category", $data.hiddenMoreClass && 'hidden'])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, item => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["category-item", $data.typeId === item.id && 'active']),
      key: item.id,
      onClick: $event => $options.searchCourseList(item.id)
    }, _toDisplayString(item.name), 11, _hoisted_7);
  }), 128))], 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [$data.homeCourseList && $data.homeCourseList.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.homeCourseList.slice(0, 3), course => {
    return _openBlock(), _createBlock(_component_CourseCard, {
      class: "home-course-card",
      "course-data": course,
      key: course.id,
      "show-label": true,
      userInfo: $props.userInfo,
      authType: $data.authType
    }, null, 8, ["course-data", "userInfo", "authType"]);
  }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_Empty)]))])])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_UserCard, {
    userInfo: $props.userInfo,
    zhsRole: $props.zhsRole
  }, null, 8, ["userInfo", "zhsRole"])])])]);
}